var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._t("default"),(_vm.exportEnabled)?_c('Button',{class:_vm.exportClass,attrs:{"type":"primary","size":_vm.exportButtonSize},on:{"click":_vm.exportExcel}},[_vm._v(_vm._s(_vm.L('Action.Export')))]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }